module.exports = __webpack_public_path__ + "img/理论法.69895b27.png";